/**
 * Circular ribbon with marquee text for the 3D scene
 */

import type * as THREE_NS from 'three';
import { ribbonVertexShader, ribbonFragmentShader } from '../utils/shaders/ribbonShader.js';

export function createCircularRibbon(
  scene: THREE_NS.Scene,
  THREE: typeof THREE_NS
): THREE_NS.Mesh[] {
  const { CylinderGeometry, ShaderMaterial, Mesh, CanvasTexture, DoubleSide } = THREE as any;

  const text =
    'MAJAKU PRIVACY SCREEN | LAYAR PRIVASI MAJAKU | SKRIN PRIVASI MAJAKU | SCREEN NG PRIVACY NG MAJAKU | หน้าจอความเป็นส่วนตัว MAJAKU | MÀN HÌNH RIÊNG TƯ MAJAKU | អេក្រង់ភាពឯកជន MAJAKU | ຈໍຄວາມເປັນສ່ວນຕົວ MAJAKU | MAJAKU ကိုယ်ပိုင်ភាពဖန်သားပြင် | LAYAR PRIVASI MAJAKU | 马佳库隐私屏幕 | 馬佳庫隱私螢幕 | マジャクプライバシースクリーン | 마자쿠 프라이버시 스크린 | MAJAKU DATENSCHUTZBILDSCHIRM | ÉCRAN DE CONFIDENTIALITÉ MAJAKU | PANTALLA DE PRIVACIDAD MAJAKU';
  const ribbonCanvas = document.createElement('canvas');
  ribbonCanvas.width = 2048;
  ribbonCanvas.height = 256;
  const ctx = ribbonCanvas.getContext('2d');
  if (ctx) {
    ctx.font = '300 19px "Bitcount Prop Double", monospace';
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, ribbonCanvas.width / 2, ribbonCanvas.height / 2);
  }
  const texture = new CanvasTexture(ribbonCanvas);

  const ribbonGeometry = new CylinderGeometry(22.5, 22.5, 2, 128, 4, true);

  const material = new ShaderMaterial({
    vertexShader: ribbonVertexShader,
    fragmentShader: ribbonFragmentShader,
    uniforms: {
      uTexture: { value: texture },
      uTime: { value: 0 },
    },
    transparent: true,
    opacity: 0.8,
    side: DoubleSide,
    depthWrite: false,
    alphaTest: 0.1,
  });

  const baseRibbon = new Mesh(ribbonGeometry, material);
  baseRibbon.position.set(0, -0.5, 0);
  baseRibbon.renderOrder = 800;
  // Circular ribbons disabled - not rendering to scene
  // scene.add(baseRibbon);

  const ribbon2 = baseRibbon.clone();
  ribbon2.rotation.z = Math.PI / 2;
  // scene.add(ribbon2);

  const ribbon3 = baseRibbon.clone();
  ribbon3.rotation.x = Math.PI / 2;
  // scene.add(ribbon3);

  return [baseRibbon, ribbon2, ribbon3];
}

/**
 * Update ribbon time uniforms for marquee scrolling
 */
export function updateRibbons(ribbonPlanes: THREE_NS.Mesh[], currentTime: number): void {
  // ribbonPlanes.forEach((ribbon) => {
  //   if (ribbon.material && (ribbon.material as any).uniforms && (ribbon.material as any).uniforms.uTime) {
  //     (ribbon.material as any).uniforms.uTime.value = currentTime;
  //   }
  // });
}
